<template lang="pug">
  .component-backoffice-category-list.row.column
    base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="true", ref="baseList")

</template>

<script>
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import GoogleMap from '../../lib/map/GoogleMap'
  import GoogleMapPolygon from '../../lib/map/GoogleMapPolygon'
  import BaseList from './BaseList'

  export default {
    name: 'ZoneList',
    components: {BaseList, GoogleMap, GoogleMapPolygon},
    data() {
      return {
        component: require('src/components/backoffice/ZoneConfig'),

      }
    },
    created() {
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.zoneConfigurations.list().all(page, resultsPerPage, (data) => {
          callback(data)
        })
      },
      editZone() {
        var zone = this.zones[this.activeIndex]
        this.$router.push({name: 'edit-zone', params: {id: zone.id}})
      }
    }
  }
</script>

<style scoped lang="sass">
  .component-backoffice-zone-list
    .map
      height: 400px

    .zone-edit
      color: white

</style>



// WEBPACK FOOTER //
// ZoneConfigList.vue?7641cf34